import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import useDashboardLogic from "./useDashboardLogic";
import NotifcationItem from "./NotifcationItem";
import NotifcationButton from "./NotifcationButton";

function DashBoardNotifcation({ data, userId, disableHeader = false, width }) {
  const theme = useTheme().palette.mode;
  const { state, action } = useDashboardLogic(data, userId);
  const { renderNotifcation, headerBoxStyle, typeCount } = state;
  const { typeHandler, seenMessage, seenAllMessage } = action;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: width ? width : "400px",
        height: "95%",
      }}
      padding={0}
      margin={0}
    >
      {/* Header */}
      {!disableHeader && (
        <Box sx={headerBoxStyle}>
          <Typography fontSize={14}> اعلان ها</Typography>

          <Button
            onClick={seenAllMessage}
            style={{ color: "#1E6AFD", fontSize: "12px" }}
          >
            خواندن همه
          </Button>
        </Box>
      )}
      <Box sx={headerBoxStyle}>
        <NotifcationButton
          typeHandler={typeHandler}
          category={10}
          title="  همه"
          typeCount={typeCount?.all}
          isActive={renderNotifcation === 10 ? true : false}
        />
        <NotifcationButton
          typeHandler={typeHandler}
          category={0}
          title="  متفرقه"
          typeCount={typeCount?.misc}
          isActive={renderNotifcation === 0 ? true : false}
        />
        <NotifcationButton
          typeHandler={typeHandler}
          category={1}
          title=" برنامه ریز"
          typeCount={typeCount?.scheduler}
          isActive={renderNotifcation === 1 ? true : false}
        />
        <NotifcationButton
          typeHandler={typeHandler}
          category={2}
          title=" سفارش"
          typeCount={typeCount?.orders}
          isActive={renderNotifcation === 2 ? true : false}
        />
        <NotifcationButton
          typeHandler={typeHandler}
          category={3}
          title=" مشتری"
          typeCount={typeCount?.customer}
          isActive={renderNotifcation === 3 ? true : false}
        />
        <NotifcationButton
          typeHandler={typeHandler}
          category={4}
          title="کارتابل پرسنلی"
          typeCount={typeCount?.personCartable}
          isActive={renderNotifcation === 4 ? true : false}
        />
      </Box>

      {/* content */}
      <Box
        display={"flex"}
        alignItems={"center"}
        padding={1}
        sx={{
          background: theme === "dark" ? "#161B25" : "#fff",
          height: "100%",
        }}
      >
        <ul
          style={{
            height: disableHeader ? "25rem" : "100%",
            width: "100%",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {data
            ?.filter(
              (item) =>
                renderNotifcation === 10 || item.category === renderNotifcation
            )
            ?.map((item, i) => {
              return (
                <NotifcationItem
                  item={item}
                  key={item.id}
                  seenMessage={seenMessage}
                  theme={theme}
                />
              );
            })}
        </ul>
      </Box>
    </Box>
  );
}

export default DashBoardNotifcation;
